import "../dashboard-sections.css";

const DUMMY = {
  strips_kg:   { value: 12000, note: "4.2% vs yesterday",  noteType: "up"      },
  cheeks_kg:   { value: 10500, note: "On target",           noteType: "neutral" },
  total_kg:    { value: 22500, note: "Updated 5m ago",      noteType: "neutral" },
  trash:       { value: 2000,  note: "8.8% waste ratio",    noteType: "down"    },
};

const ICONS = {
  strips_kg:  { icon: "⚙️", danger: false },
  cheeks_kg:  { icon: "✕",  danger: false },
  total_kg:   { icon: "📋", danger: false },
  trash:      { icon: "🗑️", danger: true  },
};

const PackingMetricCards = ({ data = DUMMY, isLoading = false }) => {
  const cards = [
    { key: "strips_kg", label: "Strips KG"  },
    { key: "cheeks_kg", label: "Cheeks KG"  },
    { key: "total_kg",  label: "Total KG"   },
    { key: "trash",     label: "Trash"      },
  ];

  return (
    <div className="pp-metric-row">
      {cards.map((c) => {
        const d = data[c.key];
        const meta = ICONS[c.key];
        return (
          <div key={c.key} className="pp-metric-card">
            <div className="pp-metric-top">
              <span className="pp-metric-label">{c.label}</span>
              <span className={`pp-metric-icon${meta.danger ? " danger" : ""}`}>{meta.icon}</span>
            </div>
            <div className={`pp-metric-value${meta.danger ? " danger" : ""}`}>
              {isLoading
                ? <span className="db-shimmer" style={{ height: 32, width: 100, display: "block" }} />
                : d?.value?.toLocaleString()
              }
            </div>
            {d?.note && (
              <div className={`pp-metric-note ${d.noteType}`}>{d.note}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PackingMetricCards;
